import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

export const api = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_URL,
        prepareHeaders: (headers, { getState }) => {
            let timezone =  Intl.DateTimeFormat().resolvedOptions().timeZone;
            headers.set('Accept','application/json');
            headers.set('Locale','en');
            headers.set('Access-Control-Allow-Methods',"GET,PATCH,DELETE,POST,PUT");
            headers.set("Timezone", timezone);
            headers.set('App-Device', 'web');
            return headers
        }
    }),
    endpoints: builder => ({
        getAllSlugs: builder.query({
            query: () => "/data/slugs",
        }),
        getAllSubSlugs: builder.query({
            query: () => "/data/subslugs",
        }),
        getBlogData: builder.query({
            query: () => "/data/blogs",
        }),
        searchLocations: builder.mutation({
            query: (payload) => ({
                url: "/data/locations",
                method: "POST",
                body: payload,
            }),
        }),
        submitPrivateTourForm: builder.mutation({
            query: (payload) => ({
                url: "/tour/private",
                method: "POST",
                body: payload,
            }),
        }),



        getCommonData: builder.query({query: () => '/data/v2/common',}),
        getCommonWorldTourData: builder.query({query: () => '/data/v2/common/world',}),

        getHomepageData: builder.query({query: () => "/data/v2/homepage",}),
        getWorldTourHomepageData: builder.query({query: () => "/data/v2/world_tours_homepage",}),
        getTermsData: builder.query({query: () => '/data/v2/terms',}),
        getPrivateToursData: builder.query({query: () => '/data/v2/private_tours',}),
        getPrivateToursFormData: builder.query({query: () => '/data/v2/private_tours_form',}),
        getPrivacyData: builder.query({query: () => '/data/v2/privacy',}),
        getJoinUsData: builder.query({query: () => '/data/v2/join_us',}),
        getGiftCardsData: builder.query({query: () => '/data/v2/gift_cards',}),
        getContactData: builder.query({query: () => '/data/v2/Contact',}),
        getBloggersData: builder.query({query: () => '/data/v2/bloggers',}),
        getAboutUsData: builder.query({query: () => '/data/v2/about_us',}),
        getNewToursData: builder.query({query: () => '/data/v2/new_tours',}),
        getReasonsToBookAPrivateTourData: builder.query({query: () => '/data/v2/reasons_to_book_a_private_tour',}),
        getFaqData: builder.query({query: () => '/data/v2/faq',}),
        getHealthAndSafetyData: builder.query({query: () => '/data/v2/health_and_safety',}),
        getDataBySlug: builder.query({
            query: (payload) => ({
                url: `/data/v2/slug/${payload?.slug}`,
                method: "GET",
            }),
        }),

    }),
    overrideExisting:false,
})


export const {
    useGetHomepageDataQuery,
    useGetWorldTourHomepageDataQuery,

    useGetTermsDataQuery,
    useGetPrivateToursDataQuery,
    useGetPrivacyDataQuery,
    useGetJoinUsDataQuery,
    useGetGiftCardsDataQuery,
    useGetContactDataQuery,
    useGetBloggersDataQuery,
    useGetAboutUsDataQuery,

    useGetBlogDataQuery,
    useSearchLocationsMutation,
    useGetDataBySlugQuery,

    useGetNewToursDataQuery,
    useGetReasonsToBookAPrivateTourDataQuery,
    useGetFaqDataQuery,

    useGetHealthAndSafetyDataQuery,

    useSubmitPrivateTourFormMutation,
} = api;
